import { Navigate, Route, Routes } from 'react-router-dom'
import VirtualIpLegacyCharacterRefinementRedirect from './VirtualIpLegacyCharacterRefinementRedirect'
import VirtualIpResumeRedirect from './VirtualIpResumeRedirect'
import VirtualIpStep1Page from './VirtualIpStep1Page'
import VirtualIpStep2Page from './VirtualIpStep2Page'
import VirtualIpStep3Page from './VirtualIpStep3Page'
import VirtualIpStep4Page from './VirtualIpStep4Page'
import VirtualIpStep5Page from './VirtualIpStep5Page'
import VirtualIpStep6VoicePage from './VirtualIpStep6VoicePage'
import VirtualIpStep7Page from './VirtualIpStep7Page'
import { VIRTUAL_IP_LEGACY_REFINEMENT_ROUTE } from './virtualIpFlow'
import { VirtualIpWorkflowProvider } from './VirtualIpWorkflowContext'

/** Canonical 7-step Virtual IP creation flow. */
export default function VirtualIpPositioningApp() {
  return (
    <VirtualIpWorkflowProvider>
      <Routes>
        <Route index element={<VirtualIpResumeRedirect />} />
        <Route path="step-1" element={<VirtualIpStep1Page />} />
        <Route path="step-2" element={<VirtualIpStep2Page />} />
        <Route path="step-3" element={<VirtualIpStep3Page />} />
        <Route path="step-4" element={<VirtualIpStep4Page />} />
        <Route path="step-5" element={<VirtualIpStep5Page />} />
        <Route path="step-6" element={<VirtualIpStep6VoicePage />} />
        <Route path="step-7" element={<VirtualIpStep7Page />} />
        <Route path={VIRTUAL_IP_LEGACY_REFINEMENT_ROUTE} element={<VirtualIpLegacyCharacterRefinementRedirect />} />
        <Route path="step-8" element={<Navigate to="../step-7" replace />} />
        <Route path="*" element={<Navigate to="." replace />} />
      </Routes>
    </VirtualIpWorkflowProvider>
  )
}
